export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_q02_b.6ef0d3ec.png";